import { StatusCodes, buildLoginRedirectUrl } from "@knowfully/ui.common";
import axios from "axios";
import { FACULTYPORTAL_BASE_URL } from "config/paths";
import { ResponseCode } from "services/facultyPortalClient";

const axiosInstance = axios.create({
  baseURL: FACULTYPORTAL_BASE_URL,
  headers: {
    "X-Requested-With": "XMLHttpRequest",
  },
});

const createNoContentResponse = () => ({
  status: StatusCodes.NO_CONTENT,
});

axiosInstance.interceptors.response.use(
  (response) => {
    if (
      response?.data?.responseCode === ResponseCode.BusinessRuleFailed ||
      response?.data?.responseCode === ResponseCode.ValidationFailed
    ) {
      return Promise.reject(response);
    }
    return response;
  },
  (error) => {
    const status = error.status ?? error.response?.status;

    if (status === StatusCodes.UNAUTHORIZED) {
      window.location.replace(buildLoginRedirectUrl(window.location.pathname));
      return Promise.resolve(createNoContentResponse());
    }

    if (status === StatusCodes.FORBIDDEN && window.location.pathname !== "/unauthorized") {
      window.location.href = "/unauthorized";
      return Promise.resolve(createNoContentResponse());
    }

    if (status === StatusCodes.INTERNAL_SERVER_ERROR && window.location.pathname !== "/error") {
      const operationId = error.response?.data?.data?.operationId;
      window.location.href = operationId
        ? `/error?operationId=${encodeURIComponent(operationId)}`
        : "/error";
      return Promise.resolve(createNoContentResponse());
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
